import "./App.scss";
import React from 'react';
import {AppRouter} from "./AppRouter";

type AppProps = {};

export class App extends React.Component<AppProps> {

    componentDidMount() {
    }

    render() {
        return (
            <div><AppRouter></AppRouter></div>
        );
    }
}


export default App;
